import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ChefHatIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
export function WhatYouTriedSection() {
  const failures = [{
    icon: BookOpenIcon,
    title: 'Los libros de cocina tradicionales',
    desc: 'Te piden ingredientes que no tienes y pasos que no quieres dar a las 7 PM.'
  }, {
    icon: ChefHatIcon,
    title: 'El "Meal Prep" agresivo',
    desc: 'Te obliga a pasar 4 horas en la cocina el domingo, robándote tu único tiempo de descanso.'
  }, {
    icon: SmartphoneIcon,
    title: 'Las apps de recetas',
    desc: 'Te dan demasiadas opciones, aumentando la fatiga de decisión en lugar de eliminarla.'
  }, {
    icon: ZapIcon,
    title: 'Improvisar cada noche',
    desc: 'Te garantiza estrés, desperdicio de comida y una cocina caótica.'
  }];
  return <section className="py-20 md:py-28 px-4 bg-warm-900 text-cream relative overflow-hidden" data-id="element-220">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-sage/30 to-transparent" data-id="element-221" />

      <div className="max-w-4xl mx-auto relative" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight mb-4" data-id="element-224">
            Por qué nada de lo que has probado{' '}
            <br className="hidden md:block" data-id="element-225" />
            <span className="italic text-sage-light font-normal" data-id="element-226">
              ha funcionado
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-227">
          {failures.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-warm-800/60 backdrop-blur-sm border border-warm-800 rounded-2xl p-6 md:p-7" data-id="element-228">
                <div className="inline-flex p-2.5 rounded-xl bg-sage/10 text-sage-light mb-4" data-id="element-229">
                  <Icon className="w-5 h-5" strokeWidth={1.75} data-id="element-230" />
                </div>
                <h3 className="text-lg md:text-xl font-heading font-semibold mb-2 text-cream" data-id="element-231">
                  {item.title}
                </h3>
                <p className="text-cream/70 leading-relaxed" data-id="element-232">{item.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-sage/30 to-transparent" data-id="element-233" />
    </section>;
}